import { createGlobalStyle } from 'styled-components'

export const AppOverrides = createGlobalStyle`
  :root {
    --cui-border-radius: 0.5rem;
    font-family: 'Montserrat';
    color: rgba(238, 239, 254, 1) !important;
    line-height: 38px;
    font-weight: 600 !important;
  }

  p {
    margin: 0 !important;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    padding: 0;
    margin: 0;
  }

  .custom__readonly {
    background: #51515225 !important;
    border: none !important;
    cursor: default !important;
  }

  .react-confirm-alert-overlay {
    background: rgba(0, 0, 0, 0.5) !important;
    z-index: 2050 !important;
  }

  .react-confirm-alert-body {
    font-family: 'Montserrat', sans-serif !important;
    text-align: center !important;
  }

  .react-confirm-alert-body h1 {
    font-size: 1.8rem;
  }

  .react-confirm-alert-button-group {
    justify-content: center !important;
  }

  .react-confirm-alert-button-group button {
    background-color: rgba(229, 100, 37, 1) !important;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 600 !important;
  }

  .react-confirm-alert-button-group button:nth-child(1) {
    background-color: transparent !important;
    color: rgba(229, 100, 37, 1) !important;
    border: 1px solid rgba(229, 100, 37, 1) !important;
  }

  .btn-primary:focus,
  .btn-primary:focus-visible,
  .btn-primary:active:focus,
  .btn-secondary:focus,
  .btn-secondary:focus-visible,
  .btn-secondary:active:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  .react-responsive-modal-modal {
    outline: none !important;
    border-radius: 12px !important;
  }

  .react-responsive-modal-closeButton:focus,
  .react-responsive-modal-closeButton:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  .react-responsive-modal-modal button:focus,
  .react-responsive-modal-modal button:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  .pdf-page {
    margin: 0 auto;
  }

  .pdf-page canvas {
    display: block;
    width: 100% !important;
    height: auto !important;
    background: white;
    clip-path: inset(5% 5% 5% 5%) !important;
  }

  .login-container span {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #EEEFFE;
  }

  .error_container {
    background: rgb(245, 185, 185);
    color: black;
    height: fit-content;
    border-radius: 5px;
  }

  .error_container p {
    margin: 0;
    padding: 0.4em;
  }

  .bg-primary {
    --cui-bg-opacity: 1;
    background-color: #053dbf !important;
  }

  .btn-primary {
    --cui-btn-bg: transparent !important;
    --cui-btn-border-color: rgba(229, 100, 37, 1) !important;
    --cui-btn-color: rgba(229, 100, 37, 1) !important;
    --cui-btn-hover-bg: rgba(229, 100, 37, 1) !important;
    --cui-btn-hover-border-color: rgba(229, 100, 37, 1) !important;
    --cui-btn-hover-color: white !important;
    --cui-btn-active-bg: rgba(229, 100, 37, 1) !important;
    --cui-btn-active-border-color: rgba(229, 100, 37, 1) !important;
    --cui-btn-active-color: white;
    --cui-btn-disabled-bg: #cccccc;
    --cui-btn-disabled-border-color: #cccccc;
    --cui-btn-disabled-color: white;
    --cui-btn-shadow: transparent !important;
    background: transparent !important;
    border: 1.5px solid rgba(229, 100, 37, 1) !important;
    border-radius: 0.5rem;
    display: flex;
    padding: 0.9375rem 1.5rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    font-weight: 700;
    color: rgba(229, 100, 37, 1) !important;
    letter-spacing: 1.25 !important;
    font-size: 0.875rem;
    transition: all 0.15s ease-in-out;
  }

  .btn-primary:hover {
    background: rgba(229, 100, 37, 1) !important;
    color: white !important;
    border-color: rgba(229, 100, 37, 1) !important;
  }

  .btn-primary:active {
    filter: brightness(0.95);
    transform: none;
  }

  .btn-secondary {
    --cui-btn-bg: transparent;
    --cui-btn-border-color: rgba(0, 0, 0, 0.25);
    --cui-btn-color: #000;
    --cui-btn-hover-bg: transparent;
    --cui-btn-hover-border-color: rgba(0, 0, 0, 0.25);
    --cui-btn-hover-color: #000;
    --cui-btn-active-bg: transparent;
    --cui-btn-active-border-color: rgba(0, 0, 0, 0.25);
    --cui-btn-active-color: #000;
    --cui-btn-disabled-bg: #cccccc;
    --cui-btn-disabled-border-color: #cccccc;
    --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
    --cui-btn-shadow: transparent !important;
    border-radius: 0.5rem;
    display: flex;
    padding: 0.9375rem 1.5rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    color: black !important;
    letter-spacing: 1.25 !important;
    font-size: 0.875rem;
    transition: all 0.15s ease-in-out;
    background-color: transparent !important;
    border: 1px solid rgba(0, 0, 0, 0.25) !important;
  }

  .btn-secondary:hover {
    background-color: transparent !important;
    border-color: rgba(0, 0, 0, 0.25) !important;
    filter: brightness(1.05);
  }

  .btn-secondary:active {
    filter: brightness(0.95);
    transform: none;
  }

  .btn-pd-sm {
    padding: 0.375rem 0.875rem !important;
  }

  .btn-close {
    height: 0.75rem;
    width: 0.75rem;
    background: transparent var(--cui-btn-close-bg) center/0.75rem auto no-repeat;
  }

  .form-control {
    display: block;
    width: 100%;
    border-radius: 8px;
    border: 1px solid #D8E0E8;
    background: #F8F9FD;
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #212529;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .form-control:focus {
    border: 1px solid #053dbf;
    background: #F8F9FD;
    box-shadow: none;
    outline: 0;
  }

  .select-company {
    margin: 0 20px 50px 20px;
    margin-left: 5px;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid rgba(165, 166, 182, 1);
    background-color: transparent !important;
    color: rgba(165, 166, 182, 1);
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%235BF4FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 16px 12px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .select-company:focus {
    border-color: rgba(229, 100, 37, 1);
    box-shadow: none;
    outline: none;
    background-color: transparent !important;
  }

  .select-company option {
    background-color: white;
    color: rgba(2, 5, 36, 1);
  }

  .sidebar {
    background: rgba(255, 255, 255, 1) !important;
    position: fixed;
    z-index: 1020;
    top: 0;
    left: 0;
    height: calc(100% - 60px) !important;
    width: 275px;
    transition: width 0.3s ease;
    border-right: 1px solid #dcdddf !important;
    border-radius: 10px;
    color: #626263;
  }

  .sidebar-fixed {
    top: 65px !important;
  }

  .dropdown-item {
    padding: 10px !important;
  }

  .dropdown-item:hover {
    background-color: rgba(229, 100, 37, 0.08);
    color: rgba(2, 5, 36, 1);
    cursor: pointer;
  }

  .table-responsive .dropdown-menu {
    right: 0;
    left: auto;
    min-width: 140px;
  }

  .material-symbols-outlined.nav-icon {
    margin-left: -19px !important;
  }

  .sidebar-nav {
    padding-top: 4px;
  }

  .nav-item {
    margin-bottom: 4px;
  }

  .nav-item .nav-link {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-top: 0.65rem;
    padding-bottom: 0.65rem;
  }

  .sidebar-collapsed {
    width: 64px;
  }

  .custom-active {
    background-color: white !important;
    color: rgba(2, 5, 36, 1) !important;
  }

  .custom-select {
    cursor: pointer;
    margin: 0 20px 50px 20px;
    margin-left: 5px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid white;
    background-color: transparent !important;
    color: white;
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23EC20CF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 16px 12px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .custom-select:focus {
    border-color: rgba(156, 255, 249, 1);
    box-shadow: none;
    outline: none;
    background-color: transparent !important;
  }

  .custom-select option {
    background-color: white;
    color: rgba(2, 5, 36, 1);
  }

  .page-item.active .page-link {
    background-color: #274b30;
    border-color: #274b30;
  }

  .page-link {
    color: #c0c0c0;
  }

  .btn:disabled,
  .btn.disabled,
  fieldset:disabled .btn {
    color: var(--cui-btn-disabled-color);
    pointer-events: none;
    background-color: var(--cui-btn-disabled-bg);
    border-color: var(--cui-btn-disabled-border-color, transparent);
    opacity: 0.65;
  }

  @media (min-width: 992px) {
    .ModalDetail {
      position: absolute;
      top: 20%;
      left: 25%;
      right: 25%;
      background-color: rgb(255, 255, 255);
      border-radius: 0.75rem;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);
    }
  }

  .bg-light {
    background: transparent linear-gradient(31deg, #F1F2F4 0%, #F1F2F4 100%) 0% 0% no-repeat padding-box !important;
  }

  @media (max-width: 991px) {
    .ModalDetail {
      position: absolute;
      top: 25%;
      left: 5%;
      right: 5%;
      bottom: 5%;
      background-color: rgb(255, 255, 255);
      overflow-y: auto;
      border-radius: 0.75rem;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);
    }
  }

  .avatar {
    position: relative;
    display: inline-flex;
    justify-content: center;
    vertical-align: middle;
    border-radius: 50em;
    transition: margin 0.15s;
    width: 2rem;
    height: 2rem;
    font-size: 0.8rem;
  }

  .avatar-img {
    width: 2.5rem;
    height: 2.5rem;
  }

  .sidebar-brand {
    background: transparent linear-gradient(180deg, #000 0%, #000 100%) 0% 0% no-repeat padding-box;
  }

  .card {
    box-shadow: 0 0px 0px rgb(0 0 0 / 5%), 0 0px 0px rgb(0 0 0 / 10%);
    border-radius: 0.75rem;
  }

  .card-reference {
    position: absolute;
    right: 0;
    top: 150px;
    padding: 1px 8px;
    text-align: center;
    background-color: #2C769C;
    height: 25px;
    margin: 0px;
    padding-top: 0px;
    color: rgb(255, 255, 255);
    border-top-left-radius: 0.3em;
    border-bottom-left-radius: 0.3em;
    box-shadow: 0 1px 6px rgb(0 0 0 / 15%), 0 1px 4px rgb(0 0 0 / 20%);
  }

  @media (max-width: 991px) {
    .px-3 {
      padding-right: 0rem !important;
      padding-left: 0rem !important;
    }
  }

  .header {
    background: #F5F5F5;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 65px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.5rem;
    z-index: 999 !important;
    border: none !important;
  }

  .mx-auto.d-md-none {
    margin-left: 1rem !important;
    margin-right: auto !important;
  }

  .pageTitle {
    background: #DCDDDF;
    width: 100% !important;
    height: 48px;
    font-family: Montserrat;
    font-weight: 400;
    font-size: 26px;
    line-height: 32px;
    letter-spacing: 0px;
    color: #020524;
    border-radius: 10px;
  }

  .recharts-layer .recharts-cartesian-axis-tick text {
    color: white !important;
    fill: white !important;
  }

  .chart-titles {
    width: 100%;
    height: 24px;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0px;
    color: #2C2C2D;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .grid-mobile-2cols {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  @media (min-width: 768px) {
    .grid-mobile-2cols {
      display: block;
    }
  }

  .login-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 50vw;
  }

  .floating-card {
    text-align: center;
    width: 500px;
    padding: 5px;
    overflow: hidden;
    height: 100%;
    background: transparent;
    border: none !important;
    border-radius: 38px;
    position: relative;
    color: white !important;
  }

  @media screen and (min-width: 768px) {
    .floating-card {
      max-width: 546px;
      height: auto;
    }
  }

  .floating-card .label {
    text-align: left !important;
    align-self: flex-start !important;
  }

  @media (max-width: 768px) {
    .login-left img {
      width: 75%;
    }

    .floating-card {
      width: 90%;
    }
  }

  .custom-sidebar {
    border-right: 1px solid #dcdddf;
  }

  @media (max-width: 768px) {
    .custom-sidebar {
      width: 100vw !important;
      min-height: 100vh;
      z-index: 2000 !important;
      background-color: white;
      transition: transform 0.3s ease-in-out;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      margin-top: 0 !important;
    }

    .custom-sidebar:not(.sidebar-open) {
      transform: translateX(-100%);
    }

    .custom-sidebar.sidebar-open {
      transform: translateX(0);
    }

    .custom-sidebar .select-company {
      width: 90% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .sidebar-backdrop {
      display: none !important;
    }
  }

  .custom-input {
    background: transparent !important;
    border: 1px solid white !important;
    color: white !important;
  }

  .custom-input option {
    background-color: rgba(2, 5, 36, 1) !important;
    color: white !important;
  }

  .custom-input:focus {
    background: transparent !important;
    color: white !important;
    border-color: rgba(229, 100, 37, 1) !important;
  }

  .custom-input::placeholder {
    color: white !important;
    opacity: 0.5 !important;
  }

  .input-flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  .list-group {
    --cui-list-group-bg: var(--cui-btn-disabled-bg);
    --cui-list-group-item-padding-x: 1.5rem;
    --cui-list-group-item-padding-y: 1.5rem;
  }

  @media screen and (max-width: 768px) {
    .modal-dialog {
      width: 100%;
      margin: 0;
    }
  }

  .modal-content {
    border-radius: 0.75rem;
    border: solid 1px #E1E1E9;
    padding: 1.125rem;
  }

  @media screen and (max-width: 768px) {
    .modal-content {
      width: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      padding: 1.25rem 1.25rem 2rem 1.25rem;
    }
  }

  .w-user-modal {
    width: 308px !important;
  }

  @media screen and (max-width: 768px) {
    .w-user-modal {
      width: 100% !important;
    }
  }

  .bg-default-image {
    position: relative;
    min-height: 100vh;
    overflow: auto;
  }

  .bg-default-image::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: -1;
  }

  .bg-default-image::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../assets/images/login_bg.png') !important;
    background-size: cover;
    background-position: center !important;
    background-attachment: fixed;
    z-index: -1;
  }

  .bg-default {
    min-height: 100vh;
    max-width: calc(100% - 275px);
  }

  span.__rdt_custom_sort_icon__ {
    height: 16px !important;
    width: 16px !important;
    color: #053dbf !important;
    padding: 20px 0 !important;
    transform: rotate(-90deg) !important;
  }

  .GUduX span.__rdt_custom_sort_icon__ i,
  .GUduX span.__rdt_custom_sort_icon__ svg {
    opacity: 1 !important;
    transform: none !important;
    color: #053dbf !important;
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: rgba(255, 255, 255, 1) !important;
    transition: margin-left 0.3s ease;
    width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
    height: 100vh;
    padding-top: 60px;
  }

  .sidebar-wrapper {
    min-width: 275px !important;
    height: 100% !important;
  }

  .content-wrapper {
    min-width: calc(100% - 275px) !important;
    height: 100% !important;
  }

  .wrapper-sidebar-collapsed {
    margin-left: 64px;
    width: calc(100% - 64px);
  }

  .main-content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    min-height: 100vh;
    padding: 0.8em;
  }

  .main-content-dashboard {
    position: relative;
    z-index: 1;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 1.5rem;
    border-radius: 32px;
  }

  .body {
    flex: 1;
    padding-bottom: 4rem !important;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media (max-width: 768px) {
    .sidebar {
      width: 0;
      overflow: hidden;
    }

    .sidebar-expanded {
      width: 256px;
    }

    .wrapper {
      margin-left: 0;
      width: 100%;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: white !important;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding: 0.7rem;
    z-index: 1040;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footer-icon {
    filter: invert(43%) sepia(4%) saturate(365%) hue-rotate(186deg) brightness(90%) contrast(90%);
  }

  html,
  body {
    overflow-x: hidden !important;
    width: 100%;
    position: relative;
  }

  .table-responsive {
    min-height: 300px !important;
    overflow: visible !important;
  }

  .table-responsive .rdt_TableHead {
    background-color: rgba(223, 224, 235, 1) !important;
    border-radius: 10px;
    overflow: hidden;
  }

  .table-responsive .rdt_TableHeadCell {
    font-family: 'Montserrat', 'sans-serif';
    color: rgba(94, 96, 114, 1);
    font-weight: 500;
    font-size: 0.875rem;
    padding: 0.7rem;
    text-transform: none;
  }

  .table-responsive .rdt_TableBody {
    border-radius: 0 0 10px 10px;
    overflow: hidden;
  }

  .table-responsive .rdt_TableRow:hover {
    background-color: rgba(223, 224, 235, 0.1);
    border-top: 1px solid #DCDDDF !important;
    border-bottom: 1px solid #DCDDDF !important;
  }

  .table-responsive .rdt_TableCell {
    padding: 0.7rem;
    font-size: 0.875rem;
    color: rgba(94, 96, 114, 1);
    max-height: 72px !important;
  }

  .table-responsive .rdt_Pagination {
    border-top: none;
    font-size: 0.875rem;
    color: rgba(94, 96, 114, 1);
    padding: 0.75rem 1rem;
  }

  .table-responsive .rdt_Pagination select {
    border: 1px solid rgba(223, 224, 235, 1);
    border-radius: 4px;
    padding: 0.25rem 0.5rem;
  }

  .table-responsive .rdt_TableRow {
    border-bottom: 1px solid #DCDDDF !important;
  }

  .table-responsive .rdt_TableRow:nth-child(even) {
    background-color: transparent;
    border-radius: 0;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1.5rem 0;
  }

  .dropstart .dropdown-toggle::before {
    display: none !important;
  }

  .dropdown-center .dropdown-toggle::after {
    display: none !important;
  }

  .search-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-right: 2rem;
  }

  .filter-text {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    border: 1px solid #DFE0EB;
    border-radius: 8px;
    color: rgba(2, 5, 36, 1);
    font-size: 0.875rem;
    background-color: white;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(94, 96, 114, 1)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 12px center;
    padding: 0.75rem 1rem 0.75rem 2.5rem;
  }

  .filter-text::placeholder {
    color: rgba(94, 96, 114, 0.5);
  }

  .filter-text:not(:placeholder-shown) {
    background-image: none;
    padding-left: 1rem;
  }

  .filter-text:focus {
    outline: none;
    border-color: rgba(229, 100, 37, 1);
  }

  .new-company-button {
    background: transparent;
    color: rgba(229, 100, 37, 1);
    border: 1px solid rgba(229, 100, 37, 1);
    border-radius: 10px;
    padding: 13px 10px;
    font-family: 'Montserrat';
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0px;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s ease;
    height: 48px;
  }

  .new-company-button:hover {
    background: rgba(229, 100, 37, 0.9);
    border: 1px solid rgba(229, 100, 37, 0.9);
    color: white;
  }

  .login-btn {
    width: 345px;
    height: 48px;
    background: #E56425;
    color: white;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    line-height: 22px;
  }

  @media screen and (max-width: 768px) {
    .login-btn {
      width: 100%;
      margin: 0;
    }
  }

  .forgot-password-btn {
    border: none;
    background: transparent;
    color: white;
    align-self: flex-end;
    font-size: 12px;
  }

  .table-header-row {
    background-color: rgba(243, 244, 249, 1);
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
    display: grid;
    grid-template-columns: 20% 17% 13% 14% 16% 5%;
    align-items: center;
    font-size: 0.875rem;
    color: rgba(94, 96, 114, 1);
    font-weight: 500;
  }

  .chart-tab {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: transparent !important;
  }

  .chart-tab div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    padding: 0.9rem;
  }

  .chart-tab span {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    color: rgba(238, 239, 254, 1);
  }

  .chart-tab span b {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
  }

  .chart-tab span .arrow {
    color: #F55C5C !important;
    vertical-align: middle;
    margin-bottom: 5px;
    font-size: 3.5rem !important;
  }

  .chart-container {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    background: transparent;
    color: #2C2C2D;
  }

  .active-tab {
    border-top: 2px solid #EC20CF;
  }

  .text-dark {
    color: rgba(2, 5, 36, 1) !important;
  }

  .upload-container {
    position: relative;
    min-height: 120px;
  }

  .custom-company-logo-upload {
    position: absolute;
    top: 80px;
    left: 280px;
    cursor: pointer;
    opacity: 0.8;
    z-index: 99999;
  }

  .custom-company-logo-upload:hover {
    cursor: pointer !important;
    opacity: 1 !important;
  }

  .company-logo-upload {
    cursor: pointer;
    background-color: #e2e2e2;
  }

  @media (max-width: 768px) {
    .upload-container {
      flex-direction: column;
      align-items: center;
    }

    .company-logo-upload {
      width: 100%;
      max-width: 320px;
      height: auto;
    }
  }

  .avaliation__container {
    display: flex;
    width: fit-content;
    height: fit-content;
    align-items: center;
    justify-content: start;
    background: transparent !important;
  }

  .like__button {
    border: none;
    margin: 0 !important;
    padding: 5px;
    background: transparent !important;
  }

  .dislike__button {
    border: none;
    margin: 0 !important;
    padding: 5px;
    background: transparent !important;
  }

  .mobile-sidebar {
    left: 0 !important;
  }

  .mobile-sidebar-overlay {
    backdrop-filter: blur(2px);
  }

  @media (max-width: 768px) {
    .wrapper {
      margin-left: 0 !important;
    }

    .content-wrapper {
      margin-left: 0 !important;
    }

    .sidebar-fixed {
      top: 0 !important;
    }
  }

  @media (min-width: 769px) {
    .wrapper {
      transition: margin-left 0.3s ease;
    }
  }
  // progress
  progress {
    border: none;
    width: 400px;
    height: 60px;
    background: crimson;
  }

  progress {
    color: rgba(229, 100, 37, 1);
  }

  progress::-moz-progress-bar {
    background: rgba(229, 100, 37, 1);
  }

  progress::-webkit-progress-value {
    background: red;
  }

  progress::-webkit-progress-bar {
    background: rgba(229, 100, 37, 1);
  }
`
